<template>
  <FreeBottomSheet :name="name">
    <template #header="{ hide }">
      <FreeHeader :is-centered="true" class="p-4">
        <template #leftAction>
          <div class="h-6 w-6 shrink-0" aria-hidden="true" />
        </template>
        <template #default>
          <h2
            class="text-text-neutral-primary text-center text-lg font-bold leading-6"
          >
            {{ t('passengersData.addMethod.v3title') }}
          </h2>
        </template>
        <template #rightAction>
          <FreeCloseButton
            @click="hide"
          />
        </template>
      </FreeHeader>
    </template>
    <template #default>
      <div class="flex w-full flex-col gap-3 px-4 pb-10">
        <p
          class="text-text-neutral-secondary px-0.5 pt-0.5 text-sm leading-snug"
        >
          {{ t('passengersData.addMethod.v3subtitle') }}
        </p>
        <button
          type="button"
          class="v3-cta-primary flex h-[72px] w-full cursor-pointer items-center gap-3.5 rounded-2xl border-0 py-0 pl-[18px] pr-4 text-left text-white"
          @click="$emit('onPhoto')"
        >
          <div
            class="flex h-9 w-9 shrink-0 items-center justify-center rounded-[10px] bg-white/20"
            aria-hidden="true"
          >
            <V3DocumentIcons name="camera" color="#ffffff" />
          </div>
          <div class="min-w-0 flex-1">
            <div class="text-base font-bold leading-tight">
              {{ t('passengersData.addMethod.byPhoto') }}
            </div>
            <div
              class="line-clamp-2 text-[13px] font-normal leading-snug opacity-90"
            >
              {{ t('passengersData.addMethod.byPhotoHint') }}
            </div>
          </div>
          <svg
            class="h-4 w-2.5 shrink-0"
            viewBox="0 0 10 16"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
          >
            <polyline points="2 2 8 8 2 14" />
          </svg>
        </button>
        <button
          type="button"
          class="v3-cta-secondary text-text-neutral-primary flex h-16 w-full cursor-pointer items-center gap-3.5 rounded-2xl border-0 py-0 pl-[18px] pr-4 text-left shadow-[0_1px_2px_rgba(0,0,0,0.04)]"
          @click="$emit('onManual')"
        >
          <div
            class="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg"
            style="background: rgb(var(--situational-lightgrey))"
            aria-hidden="true"
          >
            <V3DocumentIcons
              name="pencil"
              color="rgb(var(--text-neutral-tertiary))"
            />
          </div>
          <span class="min-w-0 flex-1 text-base font-semibold">
            {{ t('passengersData.addMethod.manually') }}
          </span>
          <V3DocumentIcons name="chev" color="var(--v3-fg-tertiary, #8e8e93)" />
        </button>
        <div
          class="v3-hint-card mt-1 flex gap-2.5 rounded-[14px] p-3.5 pl-3.5"
        >
          <div class="mt-0.5 shrink-0">
            <V3DocumentIcons name="sparkle" color="#4ebc73" />
          </div>
          <p class="text-text-neutral-primary text-[13px] leading-snug">
            {{ t('passengersData.addMethod.v3hint') }}
          </p>
        </div>
      </div>
    </template>
  </FreeBottomSheet>
</template>

<script setup lang="ts">
  // V3 Entry: референс V3_EntrySheet (JSX); оболочка — FreeBottomSheet / FreeHeader.

  import { useI18n } from 'vue-i18n';
  import { FreeBottomSheet, FreeCloseButton, FreeHeader } from 'freedom-shared';

  import V3DocumentIcons from './document-flow/V3DocumentIcons.vue';

  defineProps<{
    name: string;
    passengerType: string;
  }>();

  defineEmits<{
    onManual: [];
    onPhoto: [];
  }>();

  const { t } = useI18n();
</script>

<style scoped>
  .v3-cta-primary {
    background: #4ebc73;
  }
  .v3-cta-secondary {
    background: rgb(var(--background-neutral-secondary));
  }
  .v3-hint-card {
    background: rgba(78, 188, 115, 0.12);
  }
</style>
